import Screens from './Screens'

import { useNavigate, NavigateFunction, useLocation, Location } from 'react-router-dom'

export const enhanceNavigator = (navigate: NavigateFunction, location: Location): Navigation => ({
  push: (path, params) => navigate(path, { state: params }),
  goBack: () => navigate(-1),
  reset: () => navigate('/'),
  addListener: () => null,
  jumpTo: (path) => navigate(path, { replace: true }),
  screens: Screens,
  currentScreen: () => getCurrentScreen(location),
})

const getCurrentScreen = (location: Location) => {
  const path = location.pathname
  const scr = Object.values(Screens).find((s) => s.path === (path || '/'))

  if (scr) {
    return scr.name
  }
}

const useNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  return enhanceNavigator(navigate, location)
}

export default useNavigation
